<template>
  <nav
    class="navbar"
    :class="{
      'navbar--nav-open': navMenu||favoritesDrawer||cartDrawer
    }">
    <div class="navbar__menu-wrapper">
      <button
        class="menu-toggle"
        @click.stop="toggleMenu('navMenu')">
        <v-slide-y-transition
          group
          mode="out-in"
          leave-absolute
          hide-on-leave>
          <v-icon
            v-if="!navMenu"
            key="openNavMenu"
            medium
            color="secondary">
            menu
          </v-icon>
          <v-icon
            v-if="navMenu"
            key="closeNavMenu"
            medium
            color="secondary">
            close
          </v-icon>
        </v-slide-y-transition>
      </button>
      <div class="bug-report__button-wrapper">
        <v-tooltip bottom>
          <report-bug-form slot="activator" />
          <span>Report A Bug</span>
        </v-tooltip>
      </div>
    </div>

    <div
      class="navbar__logo-wrapper"
      @click.stop="closeMenu">
      <router-link
        class="navbar__logo navbar__logo--beta"
        :to="{
          name: 'home'
        }">
        <m-h-logo width="75" />
      </router-link>
    </div>
    <v-slide-y-transition
      group
      mode="out-in"
      class="navbar__items-wrapper">
      <v-menu
        v-if="this.$route.path !== '/checkout'"
        key="account"
        offset-y
        transition="slide-y-transition"
        class="account-menu">
        <!-- activator -->
        <button
          slot="activator"
          class="account-menu__activator-button"
          :disabled="navMenu||favoritesDrawer||cartDrawer"
          :class="{
            'account-menu__activator-button--inactive':
              navMenu||favoritesDrawer||cartDrawer
          }">
          <v-icon color="secondary">
            {{ isAuthenticated ? 'account_circle' : 'person_outline' }}
          </v-icon>
        </button>
        <!-- menu items -->
        <v-list class="account-menu__list">
          <v-list-tile
            v-for="route in accountMenuRoutes"
            :key="route.name"
            :to="{ name: route.name }"
            class="account-menu__list-item">
            <v-list-tile-avatar>
              <v-icon class="account-menu__list-icon">
                {{ route.icon }}
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title class="account-menu__list-title">
              {{ route.label }}
            </v-list-tile-title>
          </v-list-tile>
          <v-divider />
          <v-list-tile
            v-if="!isAuthenticated"
            :to="{ name: 'login' }"
            class="account-menu__login">
            <v-list-tile-avatar>
              <v-icon class="account-menu__list-icon">
                exit_to_app
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title class="account-menu__list-title">
              log in
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="isAuthenticated"
            :to="{ name: 'logout' }"
            class="account-menu__logout">
            <v-list-tile-avatar>
              <v-icon class="account-menu__list-icon">
                exit_to_app
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title class="account-menu__list-title">
              log out
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <button
        v-if="isAuthenticated && this.$route.path !== '/checkout'"
        key="favorites"
        class="navbar__favorites-button"
        :class="{
          'navbar__favorites-button--inactive':
            navMenu||cartDrawer
        }"
        @click.stop="toggleMenu('favoritesDrawer')">
        <v-icon color="secondary">
          {{ favoritesTotal > 0 ? 'star' : 'star_border' }}
        </v-icon>
      </button>
      <button
        v-if="this.$route.path !== '/checkout'"
        key="cart"
        class="navbar__cart-button"
        :class="{
          'navbar__cart-button--inactive':
            navMenu||favoritesDrawer
        }"
        @click.stop="toggleMenu('cartDrawer')">
        <v-icon color="secondary">shopping_cart</v-icon>
      </button>
    </v-slide-y-transition>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

import MHLogo from './MHLogo.vue';
import ReportBugForm from './ReportBugForm.vue';

export default {
  name: 'NavBar',
  components: {
    MHLogo,
    ReportBugForm,
  },
  computed: {
    ...mapState('app', {
      navMenu: 'navMenu',
      favoritesDrawer: 'favoritesDrawer',
      cartDrawer: 'cartDrawer',
    }),
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    favoritesTotal() {
      return this.$store.getters['user/favoritesTotal'];
    },
    accountMenuRoutes() {
      let routes = [];
      if (this.isAuthenticated) {
        routes = [
          {
            name: 'profile',
            label: 'profile',
            icon: 'account_box',
          },
          {
            name: 'order-history',
            label: 'order history',
            icon: 'receipt',
          },
          {
            name: 'my-patches',
            label: 'my patches',
            icon: 'view_agenda',
          },
          /*
          {
            name: 'account/settings',
            label: 'settings',
            icon: 'settings'
          }
          */
        ];
      } else {
        routes = [
          {
            name: 'create-account',
            label: 'create account',
            icon: 'account_circle',
          },
        ];
      }
      return routes;
    },
  },
  methods: {
    toggleMenu(menu) {
      if (this[menu] === true) {
        this.$store.dispatch('app/closeAllDrawers');
      } else {
        this.$store.dispatch('app/openMenu', menu);
      }
    },
    closeMenu() {
      this.$store.dispatch('app/closeAllDrawers');
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.navbar
  position: fixed
  display: flex
  flex-flow: row nowrap
  align-items: stretch
  justify-content: space-between
  /* places navbar above vuetify drawers */
  z-index: 8
  width: 100%
  margin: 0
  padding: 0
  background-color: $primary
  transition: $base-transition
  /* hide navbar on tiny phones in landscape mode */
  // @media screen and (max-height: 24rem) and (orientation: landscape)
  //   transform: translateY(-4rem);

  &__wrapper
    display: flex
    flex-flow: row nowrap
    flex-basis: 0
    flex-grow: 1
    flex-shrink: 1
    align-items: stretch
    align-content: stretch

  &__menu-wrapper
    @extends .navbar__wrapper
    justify-content: flex-start

  &__logo-wrapper
    @extends .navbar__wrapper
    justify-content: center

  &__items-wrapper
    @extends .navbar__wrapper
    justify-content: flex-end

.nav-button
  position: relative;
  display: flex
  align-items: center
  justify-content: center
  padding: $base-padding

  color: $secondary
  transition: $base-transition
  &::before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    color: inherit
    opacity: .12
    transition: $base-transition
  &:hover::before
    background-color: $white

.menu-toggle
  @extends .nav-button
  @media screen and (max-width: 20rem)
    padding: $base-padding $base-padding*.25

.navbar
  &__favorites-button,
  &__cart-button
    @extends .nav-button
    padding: $base-padding
    @media screen and (max-width: 20rem)
      padding: $base-padding $base-padding*.25
    &--inactive
      opacity: .25

.account-menu
  display: flex
  &__activator-button
    @extends .nav-button
    align-self: stretch
    padding: $base-padding
    @media screen and (max-width: 20rem)
      padding: $base-padding $base-padding*.25
    &--inactive
      opacity: .25
  &__list
    &-icon
      color: inherit
    &-title
      text-transform: capitalize;


.navbar__logo
  @extends .nav-button
  width: 6.5rem
  &--beta
    position: relative
    &::after
      content: ''
      position: absolute
      top: 0
      right: 0rem
      padding: $base-padding*.25 $base-padding*.5
      font-size: .65rem
      font-weight: $base-header-font-weight
      font-style: italic
      text-decoration: none
      color: $secondary
      border-radius: $base-border-radius
  &--beta
    &::after
      content: 'BETA'

.bug-report__button-wrapper
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center
  padding: $base-padding
  @media screen and (max-width: 20rem)
    padding: $base-padding $base-padding*.25

/**
 * ALT BLACK THEME STYLE
 * For when you want the navbar looking black
 * but not the whole site
 */
/**/
.navbar
  background-color: $black
  transition: $base-transition
  &--nav-open
    background-color: $primary

  &__logo
    color: $white
    background-color: $primary
/**/

// PRINTER STYLES
@media print
  .navbar
    display: none
</style>
